import {
  ReportSalesFunnelFilter,
  SalesFunnelCard,
  SalesFunnelTable
} from '@crm/features/reports/components'
import { Card, Col, Flex, Row } from 'antd'

export const ReportSalesFunnel = () => {
  return (
    <Flex vertical gap={16}>
      <ReportSalesFunnelFilter />

      <Card>
        <Row gutter={20}>
          <Col span={12}>
            <SalesFunnelCard />
          </Col>

          <Col span={12}>
            <SalesFunnelTable />
          </Col>
        </Row>
      </Card>
    </Flex>
  )
}
